import React, { useEffect, useState, useCallback } from 'react';
import Input from '../Input';
import Radio from '../Radio';
import Button from '../Button';
const { RadioGroup } = Radio;

export default function OverlayMatch(props) {
  const {
    ensureFn,
    name,
    type,
    typeOptions,
    value = [],
    hideDropdown,
    placeholder
  } = props;
  const [radioType, setRadioType] = useState(type || 'fuzzy');
  const [inputVal, setInputVal] = useState('');
  const stopPropagation = e => {
    e.stopPropagation();
  };
  useEffect(() => {
    setInputVal(value.join('\n'));
  }, [value]);
  // 确定按钮
  const ensureCallback = e => {
    stopPropagation(e);
    hideDropdown();
    ensureFn({
      name,
      type: radioType,
      value: inputVal.split('\n').filter(i => i.trim() !== '')
    });
  };
  // 取消按钮
  const cancelCallback = useCallback(
    e => {
      stopPropagation(e);
      hideDropdown();
      setInputVal(value.join('\n'));
    },
    [value]
  );
  // 清空按钮
  const clearCallback = useCallback(e => {
    stopPropagation(e);
    setInputVal('');
  }, []);
  return (
    <div className="input-match-overlay" onClick={e => e.stopPropagation()}>
      <div className="mgb10">
        <Input
          type="textarea"
          placeholder={placeholder}
          defaultValue={inputVal}
          onChange={setInputVal}
          onClick={stopPropagation}
        />
      </div>
      <div className="mgb10">
        <RadioGroup defaultValue={radioType} onChange={setRadioType}>
          {typeOptions.map((item, index) => (
            <Radio
              key={index}
              mini={true}
              value={item.value}
              label={item.label}
              className={index < typeOptions.length - 1 ? 'mgr10' : ''}
            />
          ))}
        </RadioGroup>
      </div>
      <div className="oper">
        <Button type="link" mini={true} onClick={clearCallback}>
          清空
        </Button>
        <div>
          <Button
            type="white"
            mini={true}
            className="mgr10"
            onClick={cancelCallback}
          >
            取消
          </Button>
          <Button type="primary" mini={true} onClick={ensureCallback}>
            确定
          </Button>
        </div>
      </div>
    </div>
  );
}
